import { RuleGroupType } from 'react-querybuilder'
import { buildMongoQuery, createPipeline } from './helpers'
import { ReportBuilderModel, MODEL_CONFIG } from './fields'
import type { CustomField } from './fields'
import { MongoQuery } from './index'

export interface State {
  model: ReportBuilderModel
  query: RuleGroupType | undefined
  selectedFields: CustomField[]
  mongoQuery: MongoQuery | undefined
}

export type Action =
  | { type: 'SET_MODEL', model: ReportBuilderModel }
  | { type: 'SET_QUERY', query: RuleGroupType }
  | { type: 'TOGGLE_FIELD', name: string }
  | { type: 'RUN_QUERY' }
  | { type: 'LOAD_REPORT', model: ReportBuilderModel, query: RuleGroupType, selectedFields: CustomField[] }

export const initialState: State = {
  model: 'position',
  query: undefined,
  selectedFields: MODEL_CONFIG.position.requiredFieldObjects,
  mongoQuery: undefined
}

export function reducer (state: State, action: Action): State {
  switch (action.type) {
    case 'SET_MODEL':
      return {
        model: action.model,
        query: undefined,
        selectedFields: MODEL_CONFIG[action.model].requiredFieldObjects,
        mongoQuery: undefined
      }
    case 'SET_QUERY':
      return { ...state, query: action.query, mongoQuery: undefined }
    case 'TOGGLE_FIELD': {
      const allFields = MODEL_CONFIG[state.model].fields
      const selectedFields = state.selectedFields.some(f => f.name === action.name)
        ? state.selectedFields.filter(f => f.name !== action.name)
        : [...state.selectedFields, ...allFields.filter(f => f.name === action.name)]
      return { ...state, selectedFields, mongoQuery: undefined }
    }
    case 'RUN_QUERY': {
      if (state.query === undefined) return state
      const allFields = MODEL_CONFIG[state.model].fields
      const match = buildMongoQuery(state.query, allFields)
      const pipeline = createPipeline(state.query, allFields, state.selectedFields)
      return { ...state, mongoQuery: { model: state.model, match, pipeline } }
    }
    case 'LOAD_REPORT':
      return {
        model: action.model,
        query: action.query,
        selectedFields: action.selectedFields,
        mongoQuery: undefined
      }
  }
}
